<script setup lang="ts">
import { onMounted } from "vue";
import { DeclaredUnitEnum } from "@/types/Views/MaterialDatabase/MaterialEnums";
import NewSpeckleChild from "@/types/Views/MappingWizard/NewSpeckleChild";

const props = defineProps<{
  declaredUnitEnums: { [key: string]: DeclaredUnitEnum };
  material: NewSpeckleChild;
  errorMsg?: string;
}>();

onMounted(() => {
  Object.values(props.declaredUnitEnums).map((declaredUnitEnum, index) => {
    declaredUnitEnum.index = index;
  });
});
</script>

<template>
  <div class="flex w-full flex-col">
    <select
      v-if="declaredUnitEnums"
      v-model="material.declaredUnitValuePairs[0].declaredUnit"
      class="focus:border-app-blue-600 rounded-8 h-9 w-full truncate border p-2 text-sm leading-none outline-hidden"
      :class="[errorMsg ? 'border-app-red-500' : 'border-slate-300']"
      data-cy="declared-unit-select">
      <option
        :value="-1"
        disabled
        hidden>
        Select
      </option>
      <option
        v-for="declaredUnit in Object.values(declaredUnitEnums).filter(
          (declaredUnit) =>
            declaredUnit.DisplayName !== 'MJ' &&
            declaredUnit.DisplayName !== 'A' &&
            declaredUnit.DisplayName !== 'KGKM' &&
            declaredUnit.DisplayName !== 'Other' &&
            declaredUnit.DisplayName !== 'Grams' &&
            declaredUnit.DisplayName !== 'Tons'
        )"
        :key="declaredUnit.index"
        :value="declaredUnit.index"
        data-cy="declared-unit-option">
        {{ declaredUnit.DisplayName }}
      </option>
    </select>
  </div>
</template>
